import { useEffect, useState } from "react";

import ViewSectionName from "./view-section-name";
import ViewDividerSmall from "./view-divider-sm";
import WebbLoader from "./webb-loader";

import { GetAuthUser } from "../services/user-accounts";
import { GetRoomList } from "../services/user-accounts";

export default function TeacherRoomListModule() {

  const asset = GetAuthUser();

  const [loading,setLoading]=useState(true);
  const [data,setData]=useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setData( (await GetRoomList()).data);
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);

  if (loading) return ( <> <WebbLoader /> </>)

  return (
    <>

      <div className="card rounded-wd border bg-white">

      {data && data.map((item, i) => (
        <div className="d-flex p-3 border-bottom" key={i}>

          <div className="me-auto">
            <p className="fw-bold m-0 p-0">{item.name}</p>
            <p className="small m-0 p-0">{item.shrt}</p>
          </div>
        
          <div className="text-end" style={{width:'fit-content'}}>
            <button className="btn btn-sm btn-outline-primary rounded-pill px-4 py-2">
              <small>Enter</small>
            </button>
          </div>
        </div>
      ))}
      </div>
    </>
  )
}